import { render } from "./ShowItem.vue?vue&type=template&id=251d08ea&scoped=true"
import script from "./ShowItem.vue?vue&type=script&lang=js"
export * from "./ShowItem.vue?vue&type=script&lang=js"

import "./ShowItem.vue?vue&type=style&index=0&id=251d08ea&scoped=true&lang=css"

import exportComponent from "/home/ali/PhpstormProjects/insta-catalog-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251d08ea"]])

export default __exports__